var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:_vm.$route.path.includes('/deal/') || _vm.$route.path.includes('/angebot/') || _vm.$route.path.includes('/aanbieding/')
      ? 'deal-page'
      : ''},[_c('Navbar'),_vm._v(" "),_c('div',{staticClass:"main-content columns"},[_c('div',{staticClass:"column left-gutter"}),_vm._v(" "),_c('div',{staticClass:"column main-column"},[_c('nuxt')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }